import styled from 'styled-components'

export const StyledPopupContentWrapper = styled.div`
  max-width: 485px;
`

export const StyledSubtitle = styled.div`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
  margin-top: 8px;
`

export const StyledH2 = styled.h2`
  color: #3E3E47;
  margin-top: 20px;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
`

export const StyledStepContainer = styled.div`
  color: #3E3E47;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
  display:flex;
  align-items:flex-start;
  margin-bottom: 16px;
`

export const StyledStep = styled.div`
  font-weight: 500;
  margin-right: 8px;
`

export const StyledStepText = styled.div`
  font-weight:400
`

export const StyledFooter = styled.div`
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 165%;
  letter-spacing: 0em;
  text-align: left;
  color: #3E3E47;
`
